import Api from 'src/api/Base'

class GetSpacePlans extends Api {
  requestUrl = `/api/SpacePlan`
}

export default GetSpacePlans
